import { createStyles, makeStyles } from '@material-ui/core';
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        container: function (_a) {
            var style = _a.style;
            return ({
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                color: (style && style.color) || theme.palette.text.secondary,
            });
        },
        iconComponent: function (_a) {
            var style = _a.style;
            return ({
                padding: 2,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                fontSize: "calc(".concat((style && style.fontSize) || '10px', " + 4px)"),
            });
        },
        textComponent: function (_a) {
            var style = _a.style;
            return ({
                padding: 2,
                fontFamily: 'Arial',
                fontWeight: 'bold',
                letterSpacing: '-0.21px',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                fontSize: (style && style.fontSize) || '10px',
            });
        },
    });
});
//# sourceMappingURL=style.js.map